// @generated drizzle-zero signature:sha256:5c9765445e8c57d3e7850aebebf25f3bbf92d8e35d5f6db0b224e1cc435dc6b3
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.

import type { ReadonlyJSONValue, Row } from "@rocicorp/zero";
import { createBuilder } from "@rocicorp/zero";
import type { ZeroCustomType } from "drizzle-zero";
import type { default as zeroSchema } from "./drizzle-zero.config";

export type AutomationsEnvCustomType = ZeroCustomType<typeof zeroSchema, "automations", "env">;
export type AutomationsSecretEnvCustomType = ZeroCustomType<typeof zeroSchema, "automations", "secretEnv">;
export type BillingPlansFeaturesCustomType = ZeroCustomType<typeof zeroSchema, "billingPlans", "features">;
export type BlueprintStepsConfigCustomType = ZeroCustomType<typeof zeroSchema, "blueprintSteps", "config">;
export type BlueprintsConfigCustomType = ZeroCustomType<typeof zeroSchema, "blueprints", "config">;
export type BriefResourcesMetadataCustomType = ZeroCustomType<typeof zeroSchema, "briefResources", "metadata">;
export type DocumentsMetadataCustomType = ZeroCustomType<typeof zeroSchema, "documents", "metadata">;
export type GithubInstallationsPermissionsCustomType = ZeroCustomType<typeof zeroSchema, "githubInstallations", "permissions">;
export type ImplementationUiCommentsThreadCustomType = ZeroCustomType<typeof zeroSchema, "implementationUIComments", "thread">;
export type ImplementationsSourceCustomType = ZeroCustomType<typeof zeroSchema, "implementations", "source">;
export type ImplementationsStepConfigOverridesCustomType = ZeroCustomType<typeof zeroSchema, "implementations", "stepConfigOverrides">;
export type RunMessagesPartsCustomType = ZeroCustomType<typeof zeroSchema, "runMessages", "parts">;
export type RunMessagesMentionsCustomType = ZeroCustomType<typeof zeroSchema, "runMessages", "mentions">;
export type RunMessagesMetadataCustomType = ZeroCustomType<typeof zeroSchema, "runMessages", "metadata">;
export type RunStepsTimelineMessagesCustomType = ZeroCustomType<typeof zeroSchema, "runSteps", "timelineMessages">;
export type RunStepsOutputCustomType = ZeroCustomType<typeof zeroSchema, "runSteps", "output">;
export type RunWorkflowStatesSuspensionCustomType = ZeroCustomType<typeof zeroSchema, "runWorkflowStates", "suspension">;
export type RunWorkflowStatesWaitCheckpointCustomType = ZeroCustomType<typeof zeroSchema, "runWorkflowStates", "waitCheckpoint">;
export type RunWorkflowStatesMachineContextCustomType = ZeroCustomType<typeof zeroSchema, "runWorkflowStates", "machineContext">;
export type RunWorkflowStatesFailureCustomType = ZeroCustomType<typeof zeroSchema, "runWorkflowStates", "failure">;
export type RunsStreamFormatCustomType = ZeroCustomType<typeof zeroSchema, "runs", "streamFormat">;
export type RunsUsageStatsCustomType = ZeroCustomType<typeof zeroSchema, "runs", "usageStats">;
export type RunsTimelineMessagesCustomType = ZeroCustomType<typeof zeroSchema, "runs", "timelineMessages">;
export type RunsRiskAssessmentCustomType = ZeroCustomType<typeof zeroSchema, "runs", "riskAssessment">;
export type SandboxLogsDataCustomType = ZeroCustomType<typeof zeroSchema, "sandboxLogs", "data">;
export type SandboxUsageRecordsResourcesCustomType = ZeroCustomType<typeof zeroSchema, "sandboxUsageRecords", "resources">;
export type WorkspaceMemberSettingsChannelsCustomType = ZeroCustomType<typeof zeroSchema, "workspaceMemberSettings", "channels">;
export type WorkspaceMemberSettingsTopicsCustomType = ZeroCustomType<typeof zeroSchema, "workspaceMemberSettings", "topics">;
export type WorkspaceMemberSettingsNewslettersCustomType = ZeroCustomType<typeof zeroSchema, "workspaceMemberSettings", "newsletters">;

const accountsTable = {
    "name": "accounts",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "userId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "providerId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "provider_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "auth_accounts"
} as const;
const activityLogsTable = {
    "name": "activityLogs",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "actorId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "actor_id"
        },
        "actorType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "user" | "system",
            "serverName": "actor_type"
        },
        "subjectId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "subject_id"
        },
        "subjectType": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "contact",
            "serverName": "subject_type"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ReadonlyJSONValue,
            "serverName": "meta_data"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "activity_logs"
} as const;
const automationRepositoriesTable = {
    "name": "automationRepositories",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "automationId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "automation_id"
        },
        "repositoryName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "repository_name"
        },
        "installationId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "baseBranch": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "base_branch"
        },
        "position": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "automation_repositories"
} as const;
const automationSchedulesTable = {
    "name": "automationSchedules",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "automationId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "automation_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "hourly" | "daily" | "weekly" | "monthly"
        },
        "hour": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "minute": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "dayOfMonth": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "day_of_month"
        },
        "dayOfWeek": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "day_of_week"
        },
        "timezone": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "lastTriggeredAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_triggered_at"
        },
        "nextRunAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "next_run_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "automation_schedules"
} as const;
const automationsTable = {
    "name": "automations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "instructions": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "repositoryName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "repository_name"
        },
        "installationId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "baseBranch": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "base_branch"
        },
        "enabled": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "lastRunStatus": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "last_run_status"
        },
        "lastRunAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_run_at"
        },
        "blueprintId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "blueprint_id"
        },
        "model": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "env": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as AutomationsEnvCustomType
        },
        "secretEnv": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as AutomationsSecretEnvCustomType,
            "serverName": "secret_env"
        },
        "triggerType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "schedule" | "friction",
            "serverName": "trigger_type"
        },
        "frictionMinOccurrences": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "friction_min_occurrences"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const billingAccountsTable = {
    "name": "billingAccounts",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "customerId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "customer_id"
        },
        "email": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "billing_accounts"
} as const;
const billingEntitlementsTable = {
    "name": "billingEntitlements",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "accountId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "account_id"
        },
        "feature": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "enabled": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "limit": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        }
    },
    "primaryKey": ["id"],
    "serverName": "billing_entitlements"
} as const;
const billingPlansTable = {
    "name": "billingPlans",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "active": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "price": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "currency": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "interval": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "year" | "day" | "week" | "month"
        },
        "trialPeriodDays": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "trial_period_days"
        },
        "features": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as BillingPlansFeaturesCustomType
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { [key: string]: string; }
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "billing_plans"
} as const;
const billingSubscriptionsTable = {
    "name": "billingSubscriptions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "accountId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "account_id"
        },
        "planId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "plan_id"
        },
        "status": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "incomplete" | "incomplete_expired" | "trialing" | "active" | "past_due" | "canceled" | "unpaid" | "paused"
        },
        "quantity": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "startedAt": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "cancelAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "cancel_at"
        },
        "cancelAtPeriodEnd": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "cancel_at_period_end"
        },
        "canceledAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "canceled_at"
        },
        "currentPeriodStart": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "current_period_start"
        },
        "currentPeriodEnd": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "current_period_end"
        },
        "endedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "ended_at"
        },
        "trialEndsAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "trial_ends_at"
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { [key: string]: string; }
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "billing_subscriptions"
} as const;
const blueprintStepsTable = {
    "name": "blueprintSteps",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "blueprintId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "blueprint_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "label": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "order": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "promptTemplate": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "prompt_template"
        },
        "optional": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "expectedOutputs": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[],
            "serverName": "expected_outputs"
        },
        "config": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as BlueprintStepsConfigCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "blueprint_steps"
} as const;
const blueprintsTable = {
    "name": "blueprints",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "feature" | "bug_fix" | "quick_change"
        },
        "source": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "system" | "workspace"
        },
        "parentBlueprintId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "parent_blueprint_id"
        },
        "active": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "displayOrder": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "display_order"
        },
        "config": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as BlueprintsConfigCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const briefResourcesTable = {
    "name": "briefResources",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "briefId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "brief_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "github_repository" | "linear_project" | "linear_issue"
        },
        "externalId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "external_id"
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as BriefResourcesMetadataCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "brief_resources"
} as const;
const briefsTable = {
    "name": "briefs",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "title": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "content": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "ydoc": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "draft" | "approved" | "archived"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const documentsTable = {
    "name": "documents",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "title": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "content": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "source": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as DocumentsMetadataCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"]
} as const;
const frictionItemsTable = {
    "name": "frictionItems",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "repositoryName": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "repository_name"
        },
        "scope": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "environment" | "repo" | "trevize"
        },
        "title": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "report": {
            "type": "json",
            "optional": false,
            "customType": null as unknown as { scope: "environment" | "repo" | "trevize"; title: string; whatHappened: string; wanted: string; reproduction: string; cost: { minutes?: number | undefined; retries?: number | undefined; note?: string | undefined; }; investigation?: string | undefined; relevantFiles?: string[] | undefined; tool?: string | undefined; stepName?: string | undefined; agent?: { harness?: string | undefined; model?: string | undefined; effort?: string | undefined; } | undefined; }
        },
        "tool": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "stepName": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "step_name"
        },
        "occurrenceCount": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "occurrence_count"
        },
        "totalCostMinutes": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "total_cost_minutes"
        },
        "totalRetries": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "total_retries"
        },
        "firstSeenAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "first_seen_at"
        },
        "lastSeenAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_seen_at"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "open" | "routed" | "fixing" | "resolved" | "dismissed"
        },
        "dismissedReason": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "dismissed_reason"
        },
        "externalIssue": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { tracker: "linear"; id: string; key: string; url: string; },
            "serverName": "external_issue"
        },
        "fixRunId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "fix_run_id"
        },
        "statusChangedBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "status_changed_by"
        },
        "statusChangedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "status_changed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "friction_items"
} as const;
const frictionOccurrencesTable = {
    "name": "frictionOccurrences",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "itemId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "item_id"
        },
        "runId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "source": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "cloud" | "local"
        },
        "reportedByUserId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "reported_by_user_id"
        },
        "costMinutes": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "cost_minutes"
        },
        "retries": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "agent": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { harness?: string | undefined; model?: string | undefined; effort?: string | undefined; }
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "friction_occurrences"
} as const;
const gitMetricsTable = {
    "name": "gitMetrics",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "repoFullName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "repo_full_name"
        },
        "prNumber": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "pr_number"
        },
        "prTitle": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "pr_title"
        },
        "prAuthor": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "pr_author"
        },
        "prState": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "merged" | "open" | "draft" | "closed",
            "serverName": "pr_state"
        },
        "additions": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "deletions": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "changedFiles": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "changed_files"
        },
        "createdAtGh": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at_gh"
        },
        "mergedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "merged_at"
        },
        "closedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "closed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "git_metrics"
} as const;
const githubInstallationsTable = {
    "name": "githubInstallations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "installationId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "accountId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "account_id"
        },
        "accountLogin": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "account_login"
        },
        "accountType": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "User" | "Organization",
            "serverName": "account_type"
        },
        "accountAvatarUrl": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "account_avatar_url"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "active" | "inactive" | "suspended"
        },
        "permissions": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as GithubInstallationsPermissionsCustomType
        },
        "repositorySelection": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "repository_selection"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "github_installations"
} as const;
const githubWebhookEventsTable = {
    "name": "githubWebhookEvents",
    "columns": {
        "deliveryId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "delivery_id"
        },
        "event": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "action": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "installationId": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "processedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "processed_at"
        }
    },
    "primaryKey": ["deliveryId"],
    "serverName": "github_webhook_events"
} as const;
const implementationPreviewProcessesTable = {
    "name": "implementationPreviewProcesses",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "sessionId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "session_id"
        },
        "processName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "process_name"
        },
        "isDefault": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "is_default"
        },
        "host": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "upstreamUrl": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "upstream_url"
        },
        "upstreamProvider": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "upstream_provider"
        },
        "providerProcessId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "provider_process_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "running" | "failed" | "stopped" | "starting"
        },
        "lastHealthAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_health_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "implementation_preview_processes"
} as const;
const implementationPreviewSessionsTable = {
    "name": "implementationPreviewSessions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "runId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "sandboxId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "sandbox_id"
        },
        "host": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "targetName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "target_name"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "stopped" | "active" | "starting" | "stopping" | "expired"
        },
        "expiresAt": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "expires_at"
        },
        "maxExpiresAt": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "max_expires_at"
        },
        "revokedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "revoked_at"
        },
        "createdBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by"
        },
        "lastAccessedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_accessed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "implementation_preview_sessions"
} as const;
const implementationUiCommentsTable = {
    "name": "implementationUIComments",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "runId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "previewSessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "preview_session_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "open" | "resolved" | "in_progress" | "ignored"
        },
        "body": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "sourceFile": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "source_file"
        },
        "sourceLine": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "source_line"
        },
        "sourceColumn": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "source_column"
        },
        "selectorPath": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "selector_path"
        },
        "htmlSnapshot": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "html_snapshot"
        },
        "styleSnapshot": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "style_snapshot"
        },
        "stackTrace": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "stack_trace"
        },
        "resolvedBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "resolved_by"
        },
        "resolvedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "resolved_at"
        },
        "resolutionNote": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "resolution_note"
        },
        "thread": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ImplementationUiCommentsThreadCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "implementation_ui_comments"
} as const;
const implementationsTable = {
    "name": "implementations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "briefId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "brief_id"
        },
        "prompt": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "title": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "currentRunId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "current_run_id"
        },
        "archivedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "archived_at"
        },
        "source": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ImplementationsSourceCustomType
        },
        "blueprintId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "blueprint_id"
        },
        "model": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "automationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "automation_id"
        },
        "stepConfigOverrides": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ImplementationsStepConfigOverridesCustomType,
            "serverName": "step_config_overrides"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const integrationsTable = {
    "name": "integrations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "icon": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "category": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "authType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "token" | "oauth" | "api_key" | "none",
            "serverName": "auth_type"
        },
        "schema": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ReadonlyJSONValue
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const knowledgeObservationsTable = {
    "name": "knowledgeObservations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "memorySessionId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "memory_session_id"
        },
        "project": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "title": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "subtitle": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "content": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "feature" | "decision" | "bugfix" | "refactor" | "discovery" | "change"
        },
        "facts": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[]
        },
        "concepts": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[]
        },
        "narrative": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "filesRead": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[],
            "serverName": "files_read"
        },
        "filesModified": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[],
            "serverName": "files_modified"
        },
        "discoveryTokens": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "discovery_tokens"
        },
        "embeddingGeneratedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "embedding_generated_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "knowledge_observations"
} as const;
const knowledgeSessionsTable = {
    "name": "knowledgeSessions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "memorySessionId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "memory_session_id"
        },
        "project": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "summary": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { investigated?: string[]; learned?: string[]; completed?: string[]; nextSteps?: string[]; }
        },
        "observationCount": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "observation_count"
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "endedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "ended_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "knowledge_sessions"
} as const;
const notificationsTable = {
    "name": "notifications",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "type": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "targetId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "target_id"
        },
        "targetType": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "user",
            "serverName": "target_type"
        },
        "actorId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "actor_id"
        },
        "actorType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "user" | "system",
            "serverName": "actor_type"
        },
        "subjectId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "subject_id"
        },
        "subjectType": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "contact",
            "serverName": "subject_type"
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as ReadonlyJSONValue,
            "serverName": "data"
        },
        "readAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number
        },
        "readById": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "readBy"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "notification"
} as const;
const repositoriesTable = {
    "name": "repositories",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "githubId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "github_id"
        },
        "fullName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "full_name"
        },
        "defaultBranch": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "default_branch"
        },
        "installationId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "private": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "state": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "active" | "inaccessible"
        },
        "lastUsedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_used_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const runExecutionsTable = {
    "name": "runExecutions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "sequence": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "trigger": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "initial" | "user_feedback"
        },
        "triggerEventId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "trigger_event_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "running" | "failed" | "cancelled" | "ready"
        },
        "steering": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { id: string; content: string; createdAt: string; eventId?: string | undefined; messageId?: string | undefined; }[]
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "readyAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "ready_at"
        },
        "completedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "completed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_executions"
} as const;
const runMessagesTable = {
    "name": "runMessages",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "role": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "user" | "system" | "assistant"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "parts": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunMessagesPartsCustomType
        },
        "mentions": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunMessagesMentionsCustomType
        },
        "metadata": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunMessagesMetadataCustomType
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "error" | "streaming" | "complete"
        },
        "stepId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "step_id"
        },
        "stepExecutionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "step_execution_id"
        },
        "turnId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "turn_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_messages"
} as const;
const runParticipantsTable = {
    "name": "runParticipants",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "userId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "lastActiveAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_active_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_participants"
} as const;
const runReposTable = {
    "name": "runRepos",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "repositoryName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "repository_name"
        },
        "installationId": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "installation_id"
        },
        "repoUrl": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "repo_url"
        },
        "dirName": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "dir_name"
        },
        "branch": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "baseBranch": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "base_branch"
        },
        "branchPushed": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "branch_pushed"
        },
        "prUrl": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "pr_url"
        },
        "prStatus": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "merged" | "open" | "draft" | "closed",
            "serverName": "pr_status"
        },
        "prNumber": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "pr_number"
        },
        "headSha": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "head_sha"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_repos"
} as const;
const runStepExecutionsTable = {
    "name": "runStepExecutions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "runExecutionId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_execution_id"
        },
        "runStepId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_step_id"
        },
        "sequence": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "queued" | "running" | "completed" | "failed" | "cancelled" | "waiting" | "skipped"
        },
        "outcome": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "triggerEventType": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "trigger_event_type"
        },
        "plannedModel": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "planned_model"
        },
        "overrideModel": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "override_model"
        },
        "model": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "provider": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_step_executions"
} as const;
const runStepsTable = {
    "name": "runSteps",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "blueprintStepId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "blueprint_step_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "order": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "pending" | "queued" | "running" | "completed" | "failed" | "cancelled" | "waiting" | "skipped" | "awaiting_approval" | "waiting_for_input"
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "completedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "completed_at"
        },
        "logs": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "timelineMessages": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunStepsTimelineMessagesCustomType,
            "serverName": "timeline_messages"
        },
        "error": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "agentSessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "agent_session_id"
        },
        "currentIteration": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "current_iteration"
        },
        "output": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunStepsOutputCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_steps"
} as const;
const runTurnsTable = {
    "name": "runTurns",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "queued" | "running" | "completed" | "failed" | "stopped" | "cancelled"
        },
        "prompt": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "agentSessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "agent_session_id"
        },
        "error": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "completedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "completed_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "run_turns"
} as const;
const runWorkflowStatesTable = {
    "name": "runWorkflowStates",
    "columns": {
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "enginePhase": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "queued" | "finalizing" | "waiting" | "initializing" | "executing",
            "serverName": "engine_phase"
        },
        "suspension": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunWorkflowStatesSuspensionCustomType
        },
        "userHold": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { actor: { type: "user" | "system" | "operator"; id?: string | undefined; }; startedAt: string; bufferedSteering: { id: string; content: string; createdAt: string; eventId?: string | undefined; messageId?: string | undefined; }[]; resumeRequest?: { eventId: string; requestedAt: string; } | undefined; } | null,
            "serverName": "user_hold"
        },
        "controlRequest": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { requestId: string; type: "pause_requested" | "cancel_requested"; requestedAt: string; requestedBy: { type: "user" | "system" | "operator"; id?: string | undefined; }; acknowledgedAt?: string | undefined; acknowledgedByWorkflowId?: string | undefined; } | null,
            "serverName": "control_request"
        },
        "sandboxLifecycle": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "failed" | "hibernated" | "ready" | "deleted" | "provisioning" | "deleting" | "absent" | "checkpointing" | "hibernating" | "restoring",
            "serverName": "sandbox_lifecycle"
        },
        "sandboxLifecycleChangedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "sandbox_lifecycle_changed_at"
        },
        "hibernateAfter": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "hibernate_after"
        },
        "waitCheckpointId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "wait_checkpoint_id"
        },
        "waitCheckpoint": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunWorkflowStatesWaitCheckpointCustomType,
            "serverName": "wait_checkpoint"
        },
        "lastRestoreError": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "last_restore_error"
        },
        "executionHealth": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "healthy" | "recovering" | "stalled",
            "serverName": "execution_health"
        },
        "blueprintSnapshotHash": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "blueprint_snapshot_hash"
        },
        "machineRuntime": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "machine_runtime"
        },
        "transitionSequence": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "transition_sequence"
        },
        "machineState": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as { state: string; status: "active" | "done"; } | null,
            "serverName": "machine_state"
        },
        "machineContext": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunWorkflowStatesMachineContextCustomType,
            "serverName": "machine_context"
        },
        "lastEventId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "last_event_id"
        },
        "activeStepExecutionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "active_step_execution_id"
        },
        "lastHeartbeatAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_heartbeat_at"
        },
        "recoveryStartedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "recovery_started_at"
        },
        "recoveryAttemptCount": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "recovery_attempt_count"
        },
        "healthDiagnostic": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "health_diagnostic"
        },
        "failure": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunWorkflowStatesFailureCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["runId"],
    "serverName": "run_workflow_states"
} as const;
const runsTable = {
    "name": "runs",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "type": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "autonomous" | "collaborative"
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "pending" | "queued" | "running" | "completed" | "failed" | "stopped" | "merged" | "cancelled" | "hibernated" | "waking"
        },
        "workflowVersion": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "workflow_version"
        },
        "model": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "sandboxId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "sandbox_id"
        },
        "sandboxRecordId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "sandbox_record_id"
        },
        "previewSessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "preview_session_id"
        },
        "sessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "session_id"
        },
        "workflowId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "workflow_id"
        },
        "agentSessionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "agent_session_id"
        },
        "streamFormat": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as RunsStreamFormatCustomType,
            "serverName": "stream_format"
        },
        "usageStats": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunsUsageStatsCustomType,
            "serverName": "usage_stats"
        },
        "error": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "timelineMessages": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunsTimelineMessagesCustomType,
            "serverName": "timeline_messages"
        },
        "currentStepId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "current_step_id"
        },
        "currentStepName": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "current_step_name"
        },
        "plan": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "analysis": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "riskTier": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "medium" | "low" | "high",
            "serverName": "risk_tier"
        },
        "riskAssessment": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as RunsRiskAssessmentCustomType,
            "serverName": "risk_assessment"
        },
        "title": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "currentTurnId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "current_turn_id"
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "completedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "completed_at"
        },
        "lastActivityAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_activity_at"
        },
        "archivedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "archived_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const sandboxLogsTable = {
    "name": "sandboxLogs",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "sandboxId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "sandbox_id"
        },
        "implementationId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "implementation_id"
        },
        "source": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as "system" | "stdout" | "stderr"
        },
        "data": {
            "type": "json",
            "optional": false,
            "customType": null as unknown as SandboxLogsDataCustomType
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "sandbox_logs"
} as const;
const sandboxUsageRecordsTable = {
    "name": "sandboxUsageRecords",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "source": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "implementation_step" | "follow_up"
        },
        "sourceId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "source_id"
        },
        "sandboxId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "sandbox_id"
        },
        "runId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "runExecutionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "run_execution_id"
        },
        "stepExecutionId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "step_execution_id"
        },
        "startEventId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "start_event_id"
        },
        "endEventId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "end_event_id"
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "endedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "ended_at"
        },
        "durationMs": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "duration_ms"
        },
        "size": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "medium" | "large"
        },
        "resources": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as SandboxUsageRecordsResourcesCustomType
        },
        "accuracy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "incomplete" | "legacy" | "exact" | "estimated"
        },
        "occurredAt": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "occurred_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "sandbox_usage_records"
} as const;
const sandboxesTable = {
    "name": "sandboxes",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "provider": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "currentState": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "current_state"
        }
    },
    "primaryKey": ["id"]
} as const;
const screenRecordingSessionsTable = {
    "name": "screenRecordingSessions",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "runId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "run_id"
        },
        "sandboxId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "sandbox_id"
        },
        "provider": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "caption": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "state": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "failed" | "ready" | "starting" | "stopping" | "recording" | "publishing"
        },
        "startedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "started_at"
        },
        "deadlineAt": {
            "type": "number",
            "optional": false,
            "customType": null as unknown as number,
            "serverName": "deadline_at"
        },
        "stoppedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "stopped_at"
        },
        "attachmentId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "attachment_id"
        },
        "failureCode": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "RECORDING_UNAVAILABLE" | "UNSUPPORTED_PROVIDER" | "RECORDING_ALREADY_ACTIVE" | "RECORDING_NOT_FOUND" | "RECORDING_LIMIT_REACHED" | "RECORDING_EXPIRED" | "RECORDING_TOO_LARGE" | "INVALID_RECORDING" | "STORAGE_UNAVAILABLE" | "PLAYBACK_UNAVAILABLE",
            "serverName": "failure_code"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "screen_recording_sessions"
} as const;
const tagsTable = {
    "name": "tags",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "color": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"]
} as const;
const userProfilesTable = {
    "name": "userProfiles",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "locale": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "defaultModel": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "default_model"
        },
        "lastSeenAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "last_seen_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "user_profiles"
} as const;
const usersTable = {
    "name": "users",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "email": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "emailVerified": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "email_verified"
        },
        "image": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "role": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "auth_users"
} as const;
const waitlistEntriesTable = {
    "name": "waitlistEntries",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "name": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "email": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "company": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "companySize": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "company_size"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "pending" | "invited" | "registered"
        },
        "inviteCode": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "invite_code"
        },
        "invitedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "invited_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "waitlist_entries"
} as const;
const workspaceIntegrationsTable = {
    "name": "workspaceIntegrations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "integrationId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "integration_id"
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "error" | "active" | "inactive"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "workspace_integrations"
} as const;
const workspaceInvitationsTable = {
    "name": "workspaceInvitations",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "userId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "email": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "role": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "invitedBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "invited_by"
        },
        "accepted": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean
        },
        "expiresAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "expires_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["workspaceId", "id"],
    "serverName": "workspace_invitations"
} as const;
const workspaceMemberSettingsTable = {
    "name": "workspaceMemberSettings",
    "columns": {
        "userId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "channels": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as WorkspaceMemberSettingsChannelsCustomType,
            "serverName": "notification_channels"
        },
        "topics": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as WorkspaceMemberSettingsTopicsCustomType,
            "serverName": "notification_topics"
        },
        "newsletters": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as WorkspaceMemberSettingsNewslettersCustomType
        },
        "dismissedOnboardingCards": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[],
            "serverName": "dismissed_onboarding_cards"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["userId", "workspaceId"],
    "serverName": "workspace_member_settings"
} as const;
const workspaceMembersTable = {
    "name": "workspaceMembers",
    "columns": {
        "userId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "user_id"
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "role": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "status": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "active" | "suspended" | "invited"
        },
        "invitedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "invited_at"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["userId", "workspaceId"],
    "serverName": "workspace_members"
} as const;
const workspaceRuntimeSecretsTable = {
    "name": "workspaceRuntimeSecrets",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "workspaceId": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string,
            "serverName": "workspace_id"
        },
        "key": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "description": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "createdBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "created_by"
        },
        "updatedBy": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "updated_by"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"],
    "serverName": "workspace_runtime_secrets"
} as const;
const workspacesTable = {
    "name": "workspaces",
    "columns": {
        "id": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "ownerId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "owner_id"
        },
        "slug": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "name": {
            "type": "string",
            "optional": false,
            "customType": null as unknown as string
        },
        "logo": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string
        },
        "maxConcurrentImplementations": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "max_concurrent_implementations"
        },
        "gitCommitAttributionMode": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "user" | "tervezo",
            "serverName": "git_commit_attribution_mode"
        },
        "knowledgeEnabled": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "knowledge_enabled"
        },
        "autoFixCiEnabled": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "auto_fix_ci_enabled"
        },
        "githubScreenshotSharingEnabled": {
            "type": "boolean",
            "optional": true,
            "customType": null as unknown as boolean,
            "serverName": "github_screenshot_sharing_enabled"
        },
        "linearTaskRuntime": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as "implementation" | "environment",
            "serverName": "linear_task_runtime"
        },
        "featureFlags": {
            "type": "json",
            "optional": true,
            "customType": null as unknown as string[],
            "serverName": "feature_flags"
        },
        "defaultSandboxImageId": {
            "type": "string",
            "optional": true,
            "customType": null as unknown as string,
            "serverName": "default_sandbox_image_id"
        },
        "createdAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "created_at"
        },
        "updatedAt": {
            "type": "number",
            "optional": true,
            "customType": null as unknown as number,
            "serverName": "updated_at"
        }
    },
    "primaryKey": ["id"]
} as const;
const accountsRelationships = {
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }]
} as const;
const automationRepositoriesRelationships = {
    "automation": [{ "sourceField": ["automationId"], "destField": ["id"], "destSchema": "automations", "cardinality": "one" }]
} as const;
const automationSchedulesRelationships = {
    "automation": [{ "sourceField": ["automationId"], "destField": ["id"], "destSchema": "automations", "cardinality": "one" }]
} as const;
const automationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "schedules": [{ "sourceField": ["id"], "destField": ["automationId"], "destSchema": "automationSchedules", "cardinality": "many" }],
    "repositories": [{ "sourceField": ["id"], "destField": ["automationId"], "destSchema": "automationRepositories", "cardinality": "many" }]
} as const;
const billingAccountsRelationships = {
    "billingEntitlements": [{ "sourceField": ["id"], "destField": ["accountId"], "destSchema": "billingEntitlements", "cardinality": "many" }],
    "billingSubscriptions": [{ "sourceField": ["id"], "destField": ["accountId"], "destSchema": "billingSubscriptions", "cardinality": "many" }],
    "subscription": [{ "sourceField": ["id"], "destField": ["accountId"], "destSchema": "billingSubscriptions", "cardinality": "one" }]
} as const;
const billingEntitlementsRelationships = {
    "billingAccount": [{ "sourceField": ["accountId"], "destField": ["id"], "destSchema": "billingAccounts", "cardinality": "one" }]
} as const;
const billingSubscriptionsRelationships = {
    "billingAccount": [{ "sourceField": ["accountId"], "destField": ["id"], "destSchema": "billingAccounts", "cardinality": "one" }]
} as const;
const blueprintStepsRelationships = {
    "blueprint": [{ "sourceField": ["blueprintId"], "destField": ["id"], "destSchema": "blueprints", "cardinality": "one" }]
} as const;
const blueprintsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "steps": [{ "sourceField": ["id"], "destField": ["blueprintId"], "destSchema": "blueprintSteps", "cardinality": "many" }]
} as const;
const briefResourcesRelationships = {
    "brief": [{ "sourceField": ["briefId"], "destField": ["id"], "destSchema": "briefs", "cardinality": "one" }]
} as const;
const briefsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "briefResources": [{ "sourceField": ["id"], "destField": ["briefId"], "destSchema": "briefResources", "cardinality": "many" }]
} as const;
const frictionItemsRelationships = {
    "occurrences": [{ "sourceField": ["id"], "destField": ["itemId"], "destSchema": "frictionOccurrences", "cardinality": "many" }],
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "fixRun": [{ "sourceField": ["fixRunId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const frictionOccurrencesRelationships = {
    "item": [{ "sourceField": ["itemId"], "destField": ["id"], "destSchema": "frictionItems", "cardinality": "one" }],
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "reportedBy": [{ "sourceField": ["reportedByUserId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }]
} as const;
const githubInstallationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const implementationPreviewProcessesRelationships = {
    "implementationPreviewSession": [{ "sourceField": ["sessionId"], "destField": ["id"], "destSchema": "implementationPreviewSessions", "cardinality": "one" }]
} as const;
const implementationPreviewSessionsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "implementationPreviewProcesses": [{ "sourceField": ["id"], "destField": ["sessionId"], "destSchema": "implementationPreviewProcesses", "cardinality": "many" }]
} as const;
const implementationUiCommentsRelationships = {
    "implementation": [{ "sourceField": ["implementationId"], "destField": ["id"], "destSchema": "implementations", "cardinality": "one" }],
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const implementationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }],
    "brief": [{ "sourceField": ["briefId"], "destField": ["id"], "destSchema": "briefs", "cardinality": "one" }],
    "blueprint": [{ "sourceField": ["blueprintId"], "destField": ["id"], "destSchema": "blueprints", "cardinality": "one" }],
    "currentRun": [{ "sourceField": ["currentRunId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "runs": [{ "sourceField": ["id"], "destField": ["implementationId"], "destSchema": "runs", "cardinality": "many" }],
    "steps": [{ "sourceField": ["currentRunId"], "destField": ["runId"], "destSchema": "runSteps", "cardinality": "many" }],
    "runMessages": [{ "sourceField": ["currentRunId"], "destField": ["runId"], "destSchema": "runMessages", "cardinality": "many" }]
} as const;
const knowledgeObservationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const notificationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const repositoriesRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const runExecutionsRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "stepExecutions": [{ "sourceField": ["id"], "destField": ["runExecutionId"], "destSchema": "runStepExecutions", "cardinality": "many" }]
} as const;
const runMessagesRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }],
    "stepExecution": [{ "sourceField": ["stepExecutionId"], "destField": ["id"], "destSchema": "runStepExecutions", "cardinality": "one" }]
} as const;
const runParticipantsRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }]
} as const;
const runReposRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const runStepExecutionsRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "runExecution": [{ "sourceField": ["runExecutionId"], "destField": ["id"], "destSchema": "runExecutions", "cardinality": "one" }],
    "runStep": [{ "sourceField": ["runStepId"], "destField": ["id"], "destSchema": "runSteps", "cardinality": "one" }],
    "runMessages": [{ "sourceField": ["id"], "destField": ["stepExecutionId"], "destSchema": "runMessages", "cardinality": "many" }]
} as const;
const runStepsRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "executions": [{ "sourceField": ["id"], "destField": ["runStepId"], "destSchema": "runStepExecutions", "cardinality": "many" }]
} as const;
const runTurnsRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const runWorkflowStatesRelationships = {
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const runsRelationships = {
    "runRepos": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runRepos", "cardinality": "many" }],
    "runSteps": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runSteps", "cardinality": "many" }],
    "executions": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runExecutions", "cardinality": "many" }],
    "stepExecutions": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runStepExecutions", "cardinality": "many" }],
    "workflowState": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runWorkflowStates", "cardinality": "one" }],
    "runMessages": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runMessages", "cardinality": "many" }],
    "runTurns": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runTurns", "cardinality": "many" }],
    "runParticipants": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "runParticipants", "cardinality": "many" }],
    "screenRecordingSessions": [{ "sourceField": ["id"], "destField": ["runId"], "destSchema": "screenRecordingSessions", "cardinality": "many" }],
    "sandbox": [{ "sourceField": ["sandboxRecordId"], "destField": ["id"], "destSchema": "sandboxes", "cardinality": "one" }],
    "implementation": [{ "sourceField": ["implementationId"], "destField": ["id"], "destSchema": "implementations", "cardinality": "one" }],
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const sandboxUsageRecordsRelationships = {
    "sandbox": [{ "sourceField": ["sandboxId"], "destField": ["id"], "destSchema": "sandboxes", "cardinality": "one" }],
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }]
} as const;
const sandboxesRelationships = {
    "runs": [{ "sourceField": ["id"], "destField": ["sandboxRecordId"], "destSchema": "runs", "cardinality": "many" }],
    "screenRecordingSessions": [{ "sourceField": ["id"], "destField": ["sandboxId"], "destSchema": "screenRecordingSessions", "cardinality": "many" }],
    "usageRecords": [{ "sourceField": ["id"], "destField": ["sandboxId"], "destSchema": "sandboxUsageRecords", "cardinality": "many" }]
} as const;
const screenRecordingSessionsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "run": [{ "sourceField": ["runId"], "destField": ["id"], "destSchema": "runs", "cardinality": "one" }],
    "sandbox": [{ "sourceField": ["sandboxId"], "destField": ["id"], "destSchema": "sandboxes", "cardinality": "one" }]
} as const;
const tagsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const usersRelationships = {
    "accounts": [{ "sourceField": ["id"], "destField": ["userId"], "destSchema": "accounts", "cardinality": "many" }],
    "profile": [{ "sourceField": ["id"], "destField": ["id"], "destSchema": "userProfiles", "cardinality": "one" }],
    "memberships": [{ "sourceField": ["id"], "destField": ["userId"], "destSchema": "workspaceMembers", "cardinality": "many" }],
    "workspacesViaWorkspaceMemberSettings": [{ "sourceField": ["id"], "destField": ["userId"], "destSchema": "workspaceMemberSettings", "cardinality": "many" }, { "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "many" }],
    "workspacesViaWorkspaceMembers": [{ "sourceField": ["id"], "destField": ["userId"], "destSchema": "workspaceMembers", "cardinality": "many" }, { "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "many" }]
} as const;
const workspaceIntegrationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "integration": [{ "sourceField": ["integrationId"], "destField": ["id"], "destSchema": "integrations", "cardinality": "one" }]
} as const;
const workspaceInvitationsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }],
    "inviter": [{ "sourceField": ["invitedBy"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }]
} as const;
const workspaceMemberSettingsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }]
} as const;
const workspaceMembersRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }],
    "user": [{ "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "one" }],
    "settings": [{ "sourceField": ["userId", "workspaceId"], "destField": ["userId", "workspaceId"], "destSchema": "workspaceMemberSettings", "cardinality": "one" }]
} as const;
const workspaceRuntimeSecretsRelationships = {
    "workspace": [{ "sourceField": ["workspaceId"], "destField": ["id"], "destSchema": "workspaces", "cardinality": "one" }]
} as const;
const workspacesRelationships = {
    "githubInstallations": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "githubInstallations", "cardinality": "many" }],
    "repositories": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "repositories", "cardinality": "many" }],
    "tags": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "tags", "cardinality": "many" }],
    "members": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "workspaceMembers", "cardinality": "many" }],
    "workspaceIntegrations": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "workspaceIntegrations", "cardinality": "many" }],
    "screenRecordingSessions": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "screenRecordingSessions", "cardinality": "many" }],
    "subscription": [{ "sourceField": ["id"], "destField": ["accountId"], "destSchema": "billingSubscriptions", "cardinality": "one" }],
    "authUsersViaWorkspaceMemberSettings": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "workspaceMemberSettings", "cardinality": "many" }, { "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "many" }],
    "authUsersViaWorkspaceMembers": [{ "sourceField": ["id"], "destField": ["workspaceId"], "destSchema": "workspaceMembers", "cardinality": "many" }, { "sourceField": ["userId"], "destField": ["id"], "destSchema": "users", "cardinality": "many" }]
} as const;
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
    "tables": {
        "accounts": accountsTable,
        "activityLogs": activityLogsTable,
        "automationRepositories": automationRepositoriesTable,
        "automationSchedules": automationSchedulesTable,
        "automations": automationsTable,
        "billingAccounts": billingAccountsTable,
        "billingEntitlements": billingEntitlementsTable,
        "billingPlans": billingPlansTable,
        "billingSubscriptions": billingSubscriptionsTable,
        "blueprintSteps": blueprintStepsTable,
        "blueprints": blueprintsTable,
        "briefResources": briefResourcesTable,
        "briefs": briefsTable,
        "documents": documentsTable,
        "frictionItems": frictionItemsTable,
        "frictionOccurrences": frictionOccurrencesTable,
        "gitMetrics": gitMetricsTable,
        "githubInstallations": githubInstallationsTable,
        "githubWebhookEvents": githubWebhookEventsTable,
        "implementationPreviewProcesses": implementationPreviewProcessesTable,
        "implementationPreviewSessions": implementationPreviewSessionsTable,
        "implementationUIComments": implementationUiCommentsTable,
        "implementations": implementationsTable,
        "integrations": integrationsTable,
        "knowledgeObservations": knowledgeObservationsTable,
        "knowledgeSessions": knowledgeSessionsTable,
        "notifications": notificationsTable,
        "repositories": repositoriesTable,
        "runExecutions": runExecutionsTable,
        "runMessages": runMessagesTable,
        "runParticipants": runParticipantsTable,
        "runRepos": runReposTable,
        "runStepExecutions": runStepExecutionsTable,
        "runSteps": runStepsTable,
        "runTurns": runTurnsTable,
        "runWorkflowStates": runWorkflowStatesTable,
        "runs": runsTable,
        "sandboxLogs": sandboxLogsTable,
        "sandboxUsageRecords": sandboxUsageRecordsTable,
        "sandboxes": sandboxesTable,
        "screenRecordingSessions": screenRecordingSessionsTable,
        "tags": tagsTable,
        "userProfiles": userProfilesTable,
        "users": usersTable,
        "waitlistEntries": waitlistEntriesTable,
        "workspaceIntegrations": workspaceIntegrationsTable,
        "workspaceInvitations": workspaceInvitationsTable,
        "workspaceMemberSettings": workspaceMemberSettingsTable,
        "workspaceMembers": workspaceMembersTable,
        "workspaceRuntimeSecrets": workspaceRuntimeSecretsTable,
        "workspaces": workspacesTable
    },
    "relationships": {
        "accounts": accountsRelationships,
        "automationRepositories": automationRepositoriesRelationships,
        "automationSchedules": automationSchedulesRelationships,
        "automations": automationsRelationships,
        "billingAccounts": billingAccountsRelationships,
        "billingEntitlements": billingEntitlementsRelationships,
        "billingSubscriptions": billingSubscriptionsRelationships,
        "blueprintSteps": blueprintStepsRelationships,
        "blueprints": blueprintsRelationships,
        "briefResources": briefResourcesRelationships,
        "briefs": briefsRelationships,
        "frictionItems": frictionItemsRelationships,
        "frictionOccurrences": frictionOccurrencesRelationships,
        "githubInstallations": githubInstallationsRelationships,
        "implementationPreviewProcesses": implementationPreviewProcessesRelationships,
        "implementationPreviewSessions": implementationPreviewSessionsRelationships,
        "implementationUIComments": implementationUiCommentsRelationships,
        "implementations": implementationsRelationships,
        "knowledgeObservations": knowledgeObservationsRelationships,
        "notifications": notificationsRelationships,
        "repositories": repositoriesRelationships,
        "runExecutions": runExecutionsRelationships,
        "runMessages": runMessagesRelationships,
        "runParticipants": runParticipantsRelationships,
        "runRepos": runReposRelationships,
        "runStepExecutions": runStepExecutionsRelationships,
        "runSteps": runStepsRelationships,
        "runTurns": runTurnsRelationships,
        "runWorkflowStates": runWorkflowStatesRelationships,
        "runs": runsRelationships,
        "sandboxUsageRecords": sandboxUsageRecordsRelationships,
        "sandboxes": sandboxesRelationships,
        "screenRecordingSessions": screenRecordingSessionsRelationships,
        "tags": tagsRelationships,
        "users": usersRelationships,
        "workspaceIntegrations": workspaceIntegrationsRelationships,
        "workspaceInvitations": workspaceInvitationsRelationships,
        "workspaceMemberSettings": workspaceMemberSettingsRelationships,
        "workspaceMembers": workspaceMembersRelationships,
        "workspaceRuntimeSecrets": workspaceRuntimeSecretsRelationships,
        "workspaces": workspacesRelationships
    },
    "enableLegacyQueries": false,
    "enableLegacyMutators": false
} as const;

/**
 * Represents the Zero schema type.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Schema = typeof schema;
/**
 * Represents a row from the "accounts" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Account = Row<(typeof schema)["tables"]["accounts"]>;
/**
 * Represents a row from the "activityLogs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ActivityLog = Row<(typeof schema)["tables"]["activityLogs"]>;
/**
 * Represents a row from the "automationRepositories" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AutomationRepository = Row<(typeof schema)["tables"]["automationRepositories"]>;
/**
 * Represents a row from the "automationSchedules" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type AutomationSchedule = Row<(typeof schema)["tables"]["automationSchedules"]>;
/**
 * Represents a row from the "automations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Automation = Row<(typeof schema)["tables"]["automations"]>;
/**
 * Represents a row from the "billingAccounts" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BillingAccount = Row<(typeof schema)["tables"]["billingAccounts"]>;
/**
 * Represents a row from the "billingEntitlements" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BillingEntitlement = Row<(typeof schema)["tables"]["billingEntitlements"]>;
/**
 * Represents a row from the "billingPlans" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BillingPlan = Row<(typeof schema)["tables"]["billingPlans"]>;
/**
 * Represents a row from the "billingSubscriptions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BillingSubscription = Row<(typeof schema)["tables"]["billingSubscriptions"]>;
/**
 * Represents a row from the "blueprintSteps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BlueprintStep = Row<(typeof schema)["tables"]["blueprintSteps"]>;
/**
 * Represents a row from the "blueprints" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Blueprint = Row<(typeof schema)["tables"]["blueprints"]>;
/**
 * Represents a row from the "briefResources" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type BriefResource = Row<(typeof schema)["tables"]["briefResources"]>;
/**
 * Represents a row from the "briefs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Brief = Row<(typeof schema)["tables"]["briefs"]>;
/**
 * Represents a row from the "documents" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Document = Row<(typeof schema)["tables"]["documents"]>;
/**
 * Represents a row from the "frictionItems" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type FrictionItem = Row<(typeof schema)["tables"]["frictionItems"]>;
/**
 * Represents a row from the "frictionOccurrences" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type FrictionOccurrence = Row<(typeof schema)["tables"]["frictionOccurrences"]>;
/**
 * Represents a row from the "gitMetrics" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GitMetric = Row<(typeof schema)["tables"]["gitMetrics"]>;
/**
 * Represents a row from the "githubInstallations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GithubInstallation = Row<(typeof schema)["tables"]["githubInstallations"]>;
/**
 * Represents a row from the "githubWebhookEvents" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type GithubWebhookEvent = Row<(typeof schema)["tables"]["githubWebhookEvents"]>;
/**
 * Represents a row from the "implementationPreviewProcesses" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ImplementationPreviewProcess = Row<(typeof schema)["tables"]["implementationPreviewProcesses"]>;
/**
 * Represents a row from the "implementationPreviewSessions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ImplementationPreviewSession = Row<(typeof schema)["tables"]["implementationPreviewSessions"]>;
/**
 * Represents a row from the "implementationUIComments" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ImplementationUiComment = Row<(typeof schema)["tables"]["implementationUIComments"]>;
/**
 * Represents a row from the "implementations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Implementation = Row<(typeof schema)["tables"]["implementations"]>;
/**
 * Represents a row from the "integrations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Integration = Row<(typeof schema)["tables"]["integrations"]>;
/**
 * Represents a row from the "knowledgeObservations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type KnowledgeObservation = Row<(typeof schema)["tables"]["knowledgeObservations"]>;
/**
 * Represents a row from the "knowledgeSessions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type KnowledgeSession = Row<(typeof schema)["tables"]["knowledgeSessions"]>;
/**
 * Represents a row from the "notifications" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Notification = Row<(typeof schema)["tables"]["notifications"]>;
/**
 * Represents a row from the "repositories" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Repository = Row<(typeof schema)["tables"]["repositories"]>;
/**
 * Represents a row from the "runExecutions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunExecution = Row<(typeof schema)["tables"]["runExecutions"]>;
/**
 * Represents a row from the "runMessages" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunMessage = Row<(typeof schema)["tables"]["runMessages"]>;
/**
 * Represents a row from the "runParticipants" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunParticipant = Row<(typeof schema)["tables"]["runParticipants"]>;
/**
 * Represents a row from the "runRepos" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunRepo = Row<(typeof schema)["tables"]["runRepos"]>;
/**
 * Represents a row from the "runStepExecutions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunStepExecution = Row<(typeof schema)["tables"]["runStepExecutions"]>;
/**
 * Represents a row from the "runSteps" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunStep = Row<(typeof schema)["tables"]["runSteps"]>;
/**
 * Represents a row from the "runTurns" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunTurn = Row<(typeof schema)["tables"]["runTurns"]>;
/**
 * Represents a row from the "runWorkflowStates" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type RunWorkflowState = Row<(typeof schema)["tables"]["runWorkflowStates"]>;
/**
 * Represents a row from the "runs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Run = Row<(typeof schema)["tables"]["runs"]>;
/**
 * Represents a row from the "sandboxLogs" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SandboxLog = Row<(typeof schema)["tables"]["sandboxLogs"]>;
/**
 * Represents a row from the "sandboxUsageRecords" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type SandboxUsageRecord = Row<(typeof schema)["tables"]["sandboxUsageRecords"]>;
/**
 * Represents a row from the "sandboxes" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Sandbox = Row<(typeof schema)["tables"]["sandboxes"]>;
/**
 * Represents a row from the "screenRecordingSessions" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type ScreenRecordingSession = Row<(typeof schema)["tables"]["screenRecordingSessions"]>;
/**
 * Represents a row from the "tags" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Tag = Row<(typeof schema)["tables"]["tags"]>;
/**
 * Represents a row from the "userProfiles" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type UserProfile = Row<(typeof schema)["tables"]["userProfiles"]>;
/**
 * Represents a row from the "users" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type User = Row<(typeof schema)["tables"]["users"]>;
/**
 * Represents a row from the "waitlistEntries" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WaitlistEntry = Row<(typeof schema)["tables"]["waitlistEntries"]>;
/**
 * Represents a row from the "workspaceIntegrations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkspaceIntegration = Row<(typeof schema)["tables"]["workspaceIntegrations"]>;
/**
 * Represents a row from the "workspaceInvitations" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkspaceInvitation = Row<(typeof schema)["tables"]["workspaceInvitations"]>;
/**
 * Represents a row from the "workspaceMemberSettings" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkspaceMemberSetting = Row<(typeof schema)["tables"]["workspaceMemberSettings"]>;
/**
 * Represents a row from the "workspaceMembers" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkspaceMember = Row<(typeof schema)["tables"]["workspaceMembers"]>;
/**
 * Represents a row from the "workspaceRuntimeSecrets" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type WorkspaceRuntimeSecret = Row<(typeof schema)["tables"]["workspaceRuntimeSecrets"]>;
/**
 * Represents a row from the "workspaces" table.
 * This type is auto-generated from your Drizzle schema definition.
 */
export type Workspace = Row<(typeof schema)["tables"]["workspaces"]>;

/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;

/** Defines the default types for Zero */
declare module '@rocicorp/zero' { interface DefaultTypes { schema: Schema; } }
